import React, { useState } from 'react';
import { motion } from "framer-motion";
import { useHistory, useParams, Link } from "react-router-dom";
import { onDragEnd, checkConditions, addToCart, redeemReward } from "../resources/utils";
import copy from 'copy-to-clipboard';

import styles from './Confirm.module.scss';

import Media from "../components/Media";
import Loading from "../components/Loading";
import Welcomer from "../components/Welcomer";

const variants = {
  enter: {
    x: -1000,
    opacity: 0
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: {
    zIndex: 0,
    x: 1000,
    opacity: 0
  }
};

const Confirm = ({ config, rewards, customer }) => {
  const [showDetails, toggleDetails] = useState(false);
  const [isLoading, toggleLoading] = useState(false);
  const [code, setCode] = useState(null);

  let history = useHistory();
  let { rewardID } = useParams();

  let rewardData = rewards.find(x => x.id === rewardID);
  let rewardCard = config.rewards.find(x => x.id === rewardID);

  // console.log(rewards);

  let validConditions = (rewardData && customer) ? checkConditions(rewardData.conditions, customer) : false;
  // console.log(rewardData, validConditions);

  if(isLoading) {
    return (
      <motion.div
      className={styles.confirmLoading}
      data-has-footer={false}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }}
      drag="x"
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={0.5}
      onDragEnd={(e, { offset, velocity }) => {
        onDragEnd(
          offset,
          velocity,
          () => {
            history.goBack();
          },
          () => {
            // do nothing
          },
        )
      }}
      >
        <Loading />
      </motion.div>
    )
  }

  if(code && code === 'UNTRACKED') {
    return (
      <motion.div
      className={styles.confirmFinished}
      data-has-footer={customer && customer.accountEnabled}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }}
      drag="x"
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={0.5}
      onDragEnd={(e, { offset, velocity }) => {
        onDragEnd(
          offset,
          velocity,
          () => {
            history.push('/');
          },
          () => {
            // do nothing
          },
        )
      }}
      >
        <h1>Offer redeemed!</h1>
        <Media image={rewardCard.image} />
        <strong>{rewardCard.title}</strong>

        {
          rewardData.discount && rewardData.discount.instructions &&
          <p>{ rewardData.discount.instructions }</p>
        }

        {
          (rewardData.addAction && rewardData.addAction.length !== 0) &&
          <div onClick={async() => {
            await addToCart(null, rewardData.addAction, rewardData.checkoutOnAddAction);
            toggleLoading(true);
          }} className={styles.button}>{ rewardData.checkoutOnAddAction ? 'Go to checkout' : 'Add to cart'}</div>
        }
        <Link to="/" className={styles.buttonSub}>My account</Link>
      </motion.div>
    )
  }

  if(code) {
    return (
      <motion.div
      className={styles.confirmFinished}
      data-has-footer={customer && customer.accountEnabled}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }}
      drag="x"
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={0.5}
      onDragEnd={(e, { offset, velocity }) => {
        onDragEnd(
          offset,
          velocity,
          () => {
            history.push('/');
          },
          () => {
            // do nothing
          },
        )
      }}
      >
        <h1>Offer redeemed!</h1>
        <Media image={rewardCard.image} />
        <strong>{rewardCard.title}</strong>

        <p>Use this code at the checkout:</p>
        <motion.div whileTap={{ scale: 0.9 }} className={styles.copy} onClick={() => {
          copy(code);
        }}>
          <span>{code}</span>
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.5938 0H4.21875C3.44209 0 2.8125 0.62959 2.8125 1.40625V2.8125H1.40625C0.62959 2.8125 0 3.44209 0 4.21875V13.5938C0 14.3704 0.62959 15 1.40625 15H10.7812C11.5579 15 12.1875 14.3704 12.1875 13.5938V12.1875H13.5938C14.3704 12.1875 15 11.5579 15 10.7812V1.40625C15 0.62959 14.3704 0 13.5938 0ZM10.6055 13.5938H1.58203C1.53541 13.5938 1.4907 13.5752 1.45774 13.5423C1.42477 13.5093 1.40625 13.4646 1.40625 13.418V4.39453C1.40625 4.34791 1.42477 4.3032 1.45774 4.27024C1.4907 4.23727 1.53541 4.21875 1.58203 4.21875H2.8125V10.7812C2.8125 11.5579 3.44209 12.1875 4.21875 12.1875H10.7812V13.418C10.7812 13.4646 10.7627 13.5093 10.7298 13.5423C10.6968 13.5752 10.6521 13.5938 10.6055 13.5938ZM13.418 10.7812H4.39453C4.34791 10.7812 4.3032 10.7627 4.27024 10.7298C4.23727 10.6968 4.21875 10.6521 4.21875 10.6055V1.58203C4.21875 1.53541 4.23727 1.4907 4.27024 1.45774C4.3032 1.42477 4.34791 1.40625 4.39453 1.40625H13.418C13.4646 1.40625 13.5093 1.42477 13.5423 1.45774C13.5752 1.4907 13.5938 1.53541 13.5938 1.58203V10.6055C13.5938 10.6521 13.5752 10.6968 13.5423 10.7298C13.5093 10.7627 13.4646 10.7812 13.418 10.7812Z" fill="#BBBCC7"/>
          </svg>
        </motion.div>

        {
          (rewardData.addAction && rewardData.addAction.length !== 0) &&
          <div onClick={async() => {
            await addToCart(code, rewardData.addAction, rewardData.checkoutOnAddAction);
            toggleLoading(true);
          }} className={styles.button}>{ rewardData.checkoutOnAddAction ? 'Go to checkout' : 'Add to cart'}</div>
        }
        <Link to="/" className={styles.buttonSub}>My account</Link>
      </motion.div>
    )
  }

  if(!rewardData || !rewardCard || !customer) {
    return (
      <motion.div
      className={styles.confirm}
      data-has-footer={customer && customer.accountEnabled}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }}
      drag="x"
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={0.5}
      onDragEnd={(e, { offset, velocity }) => {
        onDragEnd(
          offset,
          velocity,
          () => {
            history.goBack();
          },
          () => {
            // do nothing
          },
        )
      }}
      >
        {
          customer && customer.accountEnabled &&
          <Welcomer logo={config.logo} customer={customer} />
        }
        <div onClick={() => { history.goBack(); }} className={styles.breadcrumb}>
          <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.19752 0.123583L5.46584 0.372138C5.64366 0.53688 5.64366 0.803996 5.46584 0.968773L2.28107 3.90235H16.5446C16.7961 3.90235 17 4.09124 17 4.32422V4.67579C17 4.90877 16.7961 5.09766 16.5446 5.09766H2.28107L5.46584 8.03124C5.64366 8.19598 5.64366 8.46309 5.46584 8.62787L5.19752 8.87643C5.0197 9.04117 4.73139 9.04117 4.55357 8.87643L0.133383 4.7983C-0.0444355 4.63356 -0.0444355 4.36645 0.133383 4.20167L4.55357 0.123583C4.73139 -0.0411943 5.0197 -0.0411943 5.19752 0.123583Z" fill="#1D1D1E"/>
          </svg>
          <span>{ rewardCard && rewardCard.title ? rewardCard.title : 'Reward'}</span>
        </div>
        <strong>Something went wrong when opening this reward, please try reloading the page.</strong>
      </motion.div>
    )
  }

  if(!validConditions) {
    return (
      <motion.div
      className={styles.confirm}
      data-has-footer={customer && customer.accountEnabled}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }}
      drag="x"
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={0.5}
      onDragEnd={(e, { offset, velocity }) => {
        onDragEnd(
          offset,
          velocity,
          () => {
            history.goBack();
          },
          () => {
            // do nothing
          },
        )
      }}
      >
        {
          customer && customer.accountEnabled &&
          <Welcomer logo={config.logo} customer={customer} />
        }
        <div onClick={() => { history.goBack(); }} className={styles.breadcrumb}>
          <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.19752 0.123583L5.46584 0.372138C5.64366 0.53688 5.64366 0.803996 5.46584 0.968773L2.28107 3.90235H16.5446C16.7961 3.90235 17 4.09124 17 4.32422V4.67579C17 4.90877 16.7961 5.09766 16.5446 5.09766H2.28107L5.46584 8.03124C5.64366 8.19598 5.64366 8.46309 5.46584 8.62787L5.19752 8.87643C5.0197 9.04117 4.73139 9.04117 4.55357 8.87643L0.133383 4.7983C-0.0444355 4.63356 -0.0444355 4.36645 0.133383 4.20167L4.55357 0.123583C4.73139 -0.0411943 5.0197 -0.0411943 5.19752 0.123583Z" fill="#1D1D1E"/>
          </svg>
          <span>Redeem offer?</span>
        </div>

        <div className={styles.rewardMain}>
          <Media image={rewardCard.image} />
          <div>
            <strong>{ rewardCard.title }</strong>
            <p>You do not meet the conditions to be able to redeem this offer.</p>
          </div>
        </div>
        <div onClick={() => { history.goBack(); }} className={styles.buttonSub}>Go back</div>
      </motion.div>
    )
  }

  if(customer.points < rewardData.points) {
    return (
      <motion.div
      className={styles.confirm}
      data-has-footer={customer && customer.accountEnabled}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }}
      drag="x"
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={0.5}
      onDragEnd={(e, { offset, velocity }) => {
        onDragEnd(
          offset,
          velocity,
          () => {
            history.goBack();
          },
          () => {
            // do nothing
          },
        )
      }}
      >
        {
          customer && customer.accountEnabled &&
          <Welcomer logo={config.logo} customer={customer} />
        }
        <div onClick={() => { history.goBack(); }} className={styles.breadcrumb}>
          <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.19752 0.123583L5.46584 0.372138C5.64366 0.53688 5.64366 0.803996 5.46584 0.968773L2.28107 3.90235H16.5446C16.7961 3.90235 17 4.09124 17 4.32422V4.67579C17 4.90877 16.7961 5.09766 16.5446 5.09766H2.28107L5.46584 8.03124C5.64366 8.19598 5.64366 8.46309 5.46584 8.62787L5.19752 8.87643C5.0197 9.04117 4.73139 9.04117 4.55357 8.87643L0.133383 4.7983C-0.0444355 4.63356 -0.0444355 4.36645 0.133383 4.20167L4.55357 0.123583C4.73139 -0.0411943 5.0197 -0.0411943 5.19752 0.123583Z" fill="#1D1D1E"/>
          </svg>
          <span>Redeem offer?</span>
        </div>

        <div className={styles.rewardMain}>
          <Media image={rewardCard.image} />
          <div>
            <strong>{ rewardCard.title }</strong>
            <p>You are <strong>{rewardData.points - customer.points} points</strong> off being able to redeem this reward.</p>
          </div>
        </div>
        <div onClick={() => { history.goBack(); }} className={styles.buttonSub}>Go back</div>
        <div className={styles.links}>
          <Link to="/how" className={styles.link}>
            <span>How can I earn points?</span>
            <div>
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>
            </div>
          </Link>
        </div>
      </motion.div>
    )
  }



  return (
    <motion.div
    className={styles.confirm}
    data-has-footer={customer && customer.accountEnabled}
    variants={variants}
    initial="enter"
    animate="center"
    exit="exit"
    transition={{
      x: { type: "spring", stiffness: 300, damping: 30 },
      opacity: { duration: 0.2 }
    }}
    drag="x"
    dragConstraints={{ left: 0, right: 0 }}
    dragElastic={0.5}
    onDragEnd={(e, { offset, velocity }) => {
      onDragEnd(
        offset,
        velocity,
        () => {
          history.goBack();
        },
        () => {
          // do nothing
        },
      )
    }}
    >
      {
        customer && customer.accountEnabled &&
        <Welcomer logo={config.logo} customer={customer} />
      }
      <div onClick={() => { history.goBack(); }} className={styles.breadcrumb}>
        <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.19752 0.123583L5.46584 0.372138C5.64366 0.53688 5.64366 0.803996 5.46584 0.968773L2.28107 3.90235H16.5446C16.7961 3.90235 17 4.09124 17 4.32422V4.67579C17 4.90877 16.7961 5.09766 16.5446 5.09766H2.28107L5.46584 8.03124C5.64366 8.19598 5.64366 8.46309 5.46584 8.62787L5.19752 8.87643C5.0197 9.04117 4.73139 9.04117 4.55357 8.87643L0.133383 4.7983C-0.0444355 4.63356 -0.0444355 4.36645 0.133383 4.20167L4.55357 0.123583C4.73139 -0.0411943 5.0197 -0.0411943 5.19752 0.123583Z" fill="#1D1D1E"/>
        </svg>
        <span>Redeem offer?</span>
      </div>

      <div className={styles.rewardMain}>
        <Media image={rewardCard.image} />
        <div>
          <strong>{ rewardCard.title }</strong>
          {
            +rewardData.points === 0 ?
            <p>You are about to redeem this <strong>free</strong> reward. Please review the additional details below before redeeming.</p>
            :
            <p><strong>{rewardData.points} points</strong> will be deducted from your rewards balance. George Rewards points cannot be refunded.</p>
          }
        </div>
      </div>

      <motion.div whileTap={{ scale: 0.9 }} onClick={() => { toggleDetails(!showDetails); }} className={styles.detailsToggle}>
        <span>Additional Details</span>
        <span>{ showDetails ? '-' : '+'}</span>
      </motion.div>

      {
        showDetails &&
        <p className={styles.details}>{ decodeURIComponent(rewardCard.longDescription) }</p>
      }
      <div onClick={async() => {
        toggleLoading(true);
        let newCode = await redeemReward(customer.id, rewardID);
        if(newCode) {
          setCode(newCode);
          toggleLoading(false);
        }
      }} className={styles.button}>Redeem</div>
      <div onClick={() => { history.goBack(); }} className={styles.buttonSub}>Cancel</div>
    </motion.div>
  )
}

export default Confirm;
